import React from 'react';
import Dropdown from '../../dropdown/mainDropdown';
import IconButton from '../../button/iconButton';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../global/constants';
import { useMobileDevice } from '../../../global/useMobile';
import BottomNavigationItem from '../../bottomNavigation/subNavigation/bottomNavigationItem';

interface Props {
  renderDropdownItems?: JSX.Element;
  onFileUpload?: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
}

const CreateFilesDropdown: React.FC<Props> = ({ renderDropdownItems, onFileUpload }) => {
  const isMobile = useMobileDevice();
  return (
    <>
      <Dropdown
        isMinWidth={196}
        isRemoveMaxHeight={true}
        content={
          isMobile ? (
            <BottomNavigationItem iconName='plus-icon' />
          ) : (
            <IconButton iconName='plus-icon' size={ICON_BUTTON_SIZE.MEDIUM} variant={ICON_BUTTON_TYPE.PRIMARY} />
          )
        }
        trigger='click'>
        {renderDropdownItems}
      </Dropdown>
      <input type='file' id='upload' hidden multiple onChange={onFileUpload} aria-label='Upload file' />
    </>
  );
};

export default CreateFilesDropdown;
